import { render, staticRenderFns } from "./teacherAllot.vue?vue&type=template&id=4982e157&scoped=true&"
import script from "./teacherAllot.vue?vue&type=script&lang=js&"
export * from "./teacherAllot.vue?vue&type=script&lang=js&"
import style0 from "./teacherAllot.vue?vue&type=style&index=0&id=4982e157&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4982e157",
  null
  
)

export default component.exports